import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FarmDeviceStatus } from '@shared/model/farm-device-status.enum';

@Component({
	selector: 'sf-device-status-label',
	templateUrl: './device-status-label.component.html',
	styleUrls: ['./device-status-label.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceStatusLabelComponent {
	@Input() status: FarmDeviceStatus;
}
